import { render, staticRenderFns } from "./choose-progress-record.vue?vue&type=template&id=289d0186&scoped=true&"
import script from "./choose-progress-record.vue?vue&type=script&lang=js&"
export * from "./choose-progress-record.vue?vue&type=script&lang=js&"
import style0 from "./choose-progress-record.vue?vue&type=style&index=0&id=289d0186&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d0186",
  null
  
)

export default component.exports